// extracted by mini-css-extract-plugin
export var chip = "_ei-0";
export var filterDropdown = "_ei-5";
export var filterItem = "_ei-6";
export var icon = "_ei-1";
export var removeButton = "_ei-3";
export var removeIcon = "_ei-4";
export var separator = "_ei-2";